"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const carabiners_1 = require("@clearsummit/carabiners");
const base_1 = __importDefault(require("./base"));
const defaults_1 = require("./defaults");
const image_1 = __importDefault(require("./image"));
class User extends base_1.default {
    constructor(data = {
        id: undefined,
        app_data: {},
        email: undefined,
        first_name: undefined,
        last_name: undefined,
        token: undefined,
        accepted_tos: undefined,
        photo: undefined,
        phone: undefined,
        verified: undefined,
        subscribed: undefined,
        habits: undefined,
        deleted_habits: undefined,
        problem_flow: undefined,
        commitment_flow: undefined,
        container_preview: undefined,
        signed_up_via: undefined,
        accolades: undefined,
        product_id: undefined,
        subscription_id: undefined,
    }) {
        super(data);
        this.app_data = (0, defaults_1.defaultJSON)(data.app_data);
        this.email = (0, defaults_1.defaultString)(data.email);
        this.first_name = (0, defaults_1.defaultString)(data.first_name);
        this.last_name = (0, defaults_1.defaultString)(data.last_name);
        this.phone = (0, defaults_1.defaultString)(data.phone);
        this.token = data.token;
        this.accepted_tos = (0, defaults_1.defaultBoolean)(data.accepted_tos);
        this.photo = new image_1.default((0, defaults_1.defaultObject)(data.photo));
        this.verified = (0, defaults_1.defaultBoolean)(data.verified);
        this.subscribed = (0, defaults_1.defaultBoolean)(data.subscribed);
        this.habits = (0, defaults_1.defaultArray)(data.habits);
        this.deleted_habits = (0, defaults_1.defaultArray)(data.deleted_habits);
        this.problem_flow = (0, defaults_1.defaultBoolean)(data.problem_flow);
        this.commitment_flow = (0, defaults_1.defaultBoolean)(data.commitment_flow);
        this.container_preview = (0, defaults_1.defaultBoolean)(data.container_preview);
        this.signed_up_via = (0, defaults_1.defaultEnum)(data.signed_up_via, ['apple', 'google', 'facebook', 'email']) || 'email';
        this.accolades = (0, defaults_1.defaultBoolean)(data.accolades);
        this.product_id = (0, defaults_1.defaultString)(data.product_id);
        this.subscription_id = (0, defaults_1.defaultString)(data.subscription_id);
    }
    get profilePhotoUrl() {
        return this.photo.url ? { uri: this.photo.url } : undefined;
    }
    // Keep user in auth stack until hey finish onboarding
    get valid() {
        return !!this.id && !!this.firstName && !this.getNeedsPhoneVerification();
    }
    get productID() {
        return this.product_id;
    }
    get subscriptionID() {
        return this.subscription_id;
    }
    get fullName() {
        return (0, carabiners_1.joinStr)(this.firstName, this.lastName);
    }
    set appData(appData) {
        this.app_data = { ...this.app_data, ...appData };
    }
    get appData() {
        return this.app_data;
    }
    get firstName() {
        return this.first_name;
    }
    get lastName() {
        return this.last_name;
    }
    get hasProblemFlow() {
        return this.problem_flow;
    }
    get hasCommitmentFlow() {
        return this.commitment_flow;
    }
    get hasContainerPreview() {
        return this.container_preview;
    }
    get acceptedTOS() {
        return this.accepted_tos;
    }
    get signedUpVia() {
        return this.signed_up_via;
    }
    get hasAccolades() {
        return this.accolades;
    }
    get deletedHabits() {
        return this.deleted_habits.map(String);
    }
    getNeedsPhoneVerification() {
        // Specifies if we need to confirm the phone number for the user
        return !this.verified && this.signedUpVia !== 'apple';
    }
}
exports.default = User;
